export default "/assets/images/filter-06.5a549ec63be55869.svg";